import FAQ from 'routes/FAQ'

export default FAQ
